import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Routes from "../../Routes";
export default function Filters() {
  return (
    <Switch>
      {Routes.map((prop, key) => {
        if (prop.father === "/filters") {
          return (
            <Route
              path={prop.layout + prop.father + prop.path}
              component={prop.component}
              key={key}
            />
          );
        }
        return null;
      })}
      <Redirect from="/admin/filters" to="/admin/filters/list" />
    </Switch>
  );
}